<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-navbar">
    <div class="container-fluid">
      <a class="navbar-brand js-scroll-trigger" href="#page-top"></a>
      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarTogglerDemo01"
        aria-controls="navbarTogglerDemo01"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <!--NAVBAR CONTENT -->
      <div
        class="collapse navbar-collapse d-flex justify-content-center"
        id="navbarTogglerDemo01"
      >
        <ul class="navbar-nav mb-1 mb-lg-0 d-flex">
          <li class="nav-item">
            <a class="nav-link py-2 px-5 fs-2 fw-bold" href="#about-me"
              >About</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link py-2 px-5 fs-2 fw-bold" href="#portfolio"
              >Portfolio</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link py-2 px-5 fs-2 fw-bold" href="#certificates"
              >Certificates</a
            >
          </li>
          <li class="nav-item">
            <a class="nav-link py-2 px-5 fs-2 fw-bold" href="#contact-me"
              >Contact</a
            >
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "navbar",
};
</script>
<style scoped>
* {
  font-family: "Montserrat", sans-serif;
}
.navbar-expand-lg
  > .container-fluid
  > .navbar-collapse
  > .navbar-nav
  > li
  > a:hover,
.navbar-expand-lg
  > .container-fluid
  > .navbar-collapse
  > .navbar-nav
  > li
  > a:focus {
  color: #00adb5;
}
.bg-navbar {
  background-color: #222831;
}
</style>    